export default obj => {
  const newObject = Object.keys(obj).reduce((acc, key) => (
    obj[key] === undefined ? acc : { ...acc, [key]: obj[key] }
  ), {})
  return newObject
}
